import { Card } from "@osago/ui";
import { HowItWorks } from "@/shared/ui/HowItWorks";
import { ConfiguratorProvider } from "./model/configuratorContext";
import { SettingsPanel } from "./components/SettingsPanel";
import { PreviewPanel } from "./components/PreviewPanel";
import { WIDGET_STEPS } from "./components/widgetSteps";

export function Configurator() {
  return (
    <ConfiguratorProvider>
      <div className="mx-auto grid max-w-350 gap-6 px-6 py-8 lg:grid-cols-[380px_1fr] lg:py-10">
        <Card as="aside" padding="lg" className="min-w-0 lg:sticky lg:top-8 lg:self-start">
          <SettingsPanel />
        </Card>
        <main className="flex min-h-[640px] min-w-0 flex-col gap-4">
          <HowItWorks steps={WIDGET_STEPS} />
          <PreviewPanel />
        </main>
      </div>
    </ConfiguratorProvider>
  );
}
